"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../components/drag-and-drop-item/DragAndDropItem.js");
const React = require("react");
const PropTypes = require("prop-types");
class DragAndDropItem extends React.Component {
    constructor() {
        super(...arguments);
        this.listeners = {};
        this.ref = {
            current: null
        };
    }
    render() {
        return React.createElement("kompis-drag-and-drop-item", this.getForwardedProps(), this.props.children);
    }
    componentWillUnmount() {
        this.setState({
            element: null
        });
        this.removeAllListeners(this.ref.current);
        this.ref.current = null;
    }
    removeAllListeners(element) {
        for (const eventType in this.listeners) {
            const callback = this.listeners[eventType];
            if (typeof callback === 'function') {
                element.removeEventListener(eventType, callback);
            }
            delete this.listeners[eventType];
        }
    }
    updateEventListener(element, callback, eventType) {
        if (callback !== this.listeners[eventType]) {
            if (typeof callback === 'function') {
                element.removeEventListener(eventType, this.listeners[eventType]);
            }
            this.listeners[eventType] = callback;
            if (typeof callback === 'function') {
                element.addEventListener(eventType, this.listeners[eventType]);
            }
        }
    }
    getForwardedProps() {
        const forwardedProps = {
            ref: this.onRef.bind(this),
            class: this.props.className
        };
        for (const key in this.props) {
            if (!(key in this['constructor']['propTypes'])) {
                forwardedProps[key] = this.props[key];
            }
        }
        return forwardedProps;
    }
    onRef(element) {
        if (element === null) {
            return;
        }
        if (element !== this.ref.current && this.ref.current !== null) {
            this.removeAllListeners(this.ref.current);
        }
        this.updateAllEventListeners(element, this.props);
        this.updateAllPropValues(element, this.props);
        this.ref.current = element;
    }
    updateAllPropValues(element, props) {
        element.data = props.data;
        element.dragAngleLimit = props.dragAngleLimit;
        element.dragDirection = props.dragDirection;
        element.dragOffset = props.dragOffset;
        element.isDragged = props.isDragged;
    }
    updateAllEventListeners(element, props) {
        this.updateEventListener(element, props.onDragItem, "dragItem");
        this.updateEventListener(element, props.onGhostPositionUpdate, "ghostPositionUpdate");
        this.updateEventListener(element, props.onInvalidDrag, "invalidDrag");
    }
}
DragAndDropItem.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    dragAngleLimit: PropTypes.number,
    dragDirection: PropTypes.string,
    dragOffset: PropTypes.number,
    isDragged: PropTypes.bool,
    onDragItem: PropTypes.func,
    onInvalidDrag: PropTypes.func,
    onGhostPositionUpdate: PropTypes.func
};
exports.default = DragAndDropItem;
